/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSettingsAPI = /* GraphQL */ `
  query GetSettingsAPI($id: ID!) {
    getSettingsAPI(id: $id) {
      id
      username
      email
      phone_number
      sub
      user
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSettingsAPIS = /* GraphQL */ `
  query ListSettingsAPIS(
    $filter: ModelSettingsAPIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSettingsAPIS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        email
        phone_number
        sub
        user
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSettingsAPIS = /* GraphQL */ `
  query SyncSettingsAPIS(
    $filter: ModelSettingsAPIFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSettingsAPIS(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        username
        email
        phone_number
        sub
        user
        owner
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
